module.exports = ["66,165,245","141,110,99","189,189,189","120,144,156","102,187,106","38,166,154","156,204,101","92,107,192","229,115,115","109,76,65","55,71,79","116,185,255","99,110,114","250,177,160","0,184,148","162,155,254","45,52,54","27,20,100","131,52,113","44,44,84","34,112,147","75,75,75","192,92,126","41,52,98","138,198,209","87,79,125","84,14,51","72,76,127","82,82,82","0,87,146","77,90,140","85,167,149","141,184,124","214,64,114","106,96,169","241,64,75"]


//////////////////
// WEBPACK FOOTER
// ./src/components/PortfolioDashboard/navigationPages/Component page/AssetClass/section1/colors.json
// module id = 350
// module chunks = 0